module.exports = __webpack_public_path__ + "static/blog-thumb-0-6f653243c4edbfb7302fcfe1307ea3c7.jpg";